import * as AUTHORITIES from '../../../../constants/authorities'

export default [
  {
    title: 'Dashboard Alpha',
    key: 'dashboardAlpha',
    url: '/dashboard/alpha',
    icon: 'icmn icmn-stack',
  },
  {
    divider: true,
  },
  {
    title: 'Sponsor Bank Management',
    key: 'sponserBankManagment',
    icon: 'icmn icmn-cog',
    requiredRole: AUTHORITIES.CAN_GET_SPONSOR_BANK_LIST,
    children: [
      {
        title: 'Configured Banks',
        key: 'configuredBanks',
        icon: 'icmn icmn-cog',
        url: '/sponsor/banks/configured',
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: 'Merchant Managment',
    key: 'merchantManagement',
    icon: 'icmn icmn-cog',
    requiredRole: AUTHORITIES.CAN_VIEW_MERCHANTS,
    children: [
      {
        title: 'Create Merchant',
        key: 'createMerchant',
        icon: 'icmn icmn-cog',
        requiredRole: AUTHORITIES.CAN_CREATE_MERCHANT,
        url: '/merchants/create',
      },
      {
        title: 'Merchants',
        key: 'merchants',
        icon: 'icmn icmn-cog',
        requiredRole: AUTHORITIES.CAN_VIEW_MERCHANTS,
        url: '/merchants',
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: 'User Management',
    key: 'userManagement',
    icon: 'icmn icmn-cog',
    requiredRole: 'some-no-existent-role',
    children: [
      {
        key: 'makerCheckerMapping',
        title: 'Authorizer Mapping',
        url: '/user/authorizer/mapping',
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: 'Workflows',
    key: 'workflows',
    icon: 'icmn icmn-cog',
    requiredRole: 'some-no-existent-role',
    children: [
      {
        key: 'myRequests',
        title: 'My Requests',
        url: '/workflow/myWorkflowRequests',
      },
      {
        key: 'pendingApprovals',
        title: 'Pending Approvals',
        url: '/workflow/pendingApprovals',
      },
      {
        key: 'checkedRequests',
        title: 'Checked Requests',
        url: '/workflow/checkedRequests',
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js